import { z } from "zod";
// Zod schema for URL-safe product identifiers
// Allows alphanumeric characters, hyphens, underscores, and periods
// These characters are safe to use in URLs without encoding
export const urlSafeIdentifierSchema = z
	.string()
	.regex(/^[a-zA-Z0-9._-]+$/, "Product ID must be URL-safe (only letters, numbers, dots, hyphens, and underscores)");

export const isUrlSafeIdentifier = (value: string): boolean => {
	return urlSafeIdentifierSchema.safeParse(value).success;
};

export const getUrlSafeValidationError = (value: string | undefined): string | null => {
	if (!value) {
		return null; // Empty values are handled by required field validation
	}
	const result = urlSafeIdentifierSchema
		.enrich({ callSite: "getUrlSafeValidationError" })
		.safeParseWithTelemetry(value);
	if (result.success) {
		return null;
	}
	return result.error.issues[0]?.message ?? "Invalid Product ID";
};
